import { Button, Text, WarningIcon } from '@viapeople/components'
import { isRouteErrorResponse, useLocation, useNavigate, useRouteError } from 'react-router-dom'

export function RouteErrorBoundary() {
	const error = useRouteError()
	const location = useLocation()
	const navigate = useNavigate()
	const is404 = isRouteErrorResponse(error) && error.status === 404
	const statusCode = isRouteErrorResponse(error) ? error.status : null
	const attemptedPath = `${location.pathname}${location.search}`

	return (
		<main className='flex min-h-screen items-center justify-center bg-neutral-50 px-4'>
			<div className='text-center max-w-md'>
				<WarningIcon size={48} className='mx-auto mb-4 fill-neutral-400' />
				{statusCode && <div className='text-sm font-medium text-primary-600 mb-2'>{statusCode}</div>}
				<h1 className='text-2xl font-semibold text-neutral-900 mb-2'>
					{is404 ? 'Page not found' : 'Something went wrong'}
				</h1>
				<Text className='text-neutral-600 mb-4'>
					{is404
						? "The page you're looking for doesn't exist or has been moved."
						: 'We hit an unexpected error. Try refreshing, or head back to your dashboard.'}
				</Text>
				<div className='mb-6 inline-block max-w-full rounded-sm border border-neutral-200 bg-neutral-100 px-3 py-1.5 font-mono text-xs text-neutral-700 break-all'>
					{attemptedPath}
				</div>
				<div className='flex items-center justify-center gap-2'>
					<Button onClick={() => navigate('/dashboard')}>Go to Dashboard</Button>
					{!is404 && (
						<Button variant='secondary' onClick={() => window.location.reload()}>
							Refresh
						</Button>
					)}
				</div>
			</div>
		</main>
	)
}
